/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Date_YearInputs */

const en_us2_onboarding_date_year = /** @type {(inputs: Onboarding_Date_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YYYY`)
};

const pt_br2_onboarding_date_year = /** @type {(inputs: Onboarding_Date_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aaaa`)
};

const es_419_onboarding_date_year = /** @type {(inputs: Onboarding_Date_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aaaa`)
};

const pt_pt2_onboarding_date_year = /** @type {(inputs: Onboarding_Date_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aaaa`)
};

const fr_fr2_onboarding_date_year = /** @type {(inputs: Onboarding_Date_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAAA`)
};

const de_de2_onboarding_date_year = /** @type {(inputs: Onboarding_Date_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JJJJ`)
};

const it_it2_onboarding_date_year = /** @type {(inputs: Onboarding_Date_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAAA`)
};

/**
* | output |
* | --- |
* | "YYYY" |
*
* @param {Onboarding_Date_YearInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_date_year = /** @type {((inputs?: Onboarding_Date_YearInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Date_YearInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_date_year(inputs)
	if (locale === "es-419") return es_419_onboarding_date_year(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_date_year(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_date_year(inputs)
	if (locale === "de-DE") return de_de2_onboarding_date_year(inputs)
	if (locale === "it-IT") return it_it2_onboarding_date_year(inputs)
	return en_us2_onboarding_date_year(inputs)
});
export { onboarding_date_year as "onboarding.date_year" }